import React from 'react'
import { Link } from 'react-router-dom'
import { useSEO } from '../hooks/useSEO'

export function ForbiddenPage() {
  useSEO({
    title: 'Ingen adgang (403) - BoSteendahl.dk',
    description: 'Du har ikke adgang til den pågældende side på BoSteendahl.dk.',
  })

  return (
    <div className="min-h-[70vh] flex items-center justify-center py-20 px-4 sm:px-6 bg-[#FAF8F5]">
      <div className="max-w-xl w-full text-center bg-white rounded-3xl p-8 sm:p-12 shadow-sm border border-[#E5E0D8]">
        <div className="w-16 h-16 mx-auto rounded-full bg-amber-50 text-amber-600 flex items-center justify-center text-2xl mb-4">
          <i className="fa-solid fa-lock" aria-hidden="true" />
        </div>
        <span className="text-4xl font-serif font-bold text-[#7c875a] block mb-2">
          403
        </span>
        <h1 className="font-serif text-3xl font-bold text-[#1b3a4b] mb-4">
          Ingen adgang
        </h1>
        <p className="text-sm sm:text-base text-[#64748B] leading-relaxed mb-8">
          Du har desværre ikke tilladelse eller adgang til at se denne side eller ressource.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 bg-[#1b3a4b] hover:bg-[#132835] text-white px-6 py-3.5 rounded-full text-sm font-semibold transition shadow-sm"
          >
            <i className="fa-solid fa-house text-xs text-[#7c875a]" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
          <Link
            to="/kontakt"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-[#E5E0D8] hover:border-[#1b3a4b] text-[#1b3a4b] px-6 py-3.5 rounded-full text-sm font-medium transition hover:bg-[#FAF8F5]"
          >
            <span>Kontakt Bo</span>
          </Link>
        </div>
      </div>
    </div>
  )
}
